import moment from "moment";
import { useEffect, useState } from "react";

export const WinDims = () => {
  const hasWindow = typeof window !== "undefined";
  function getWindowDimensions() {
    const width = hasWindow ? window.innerWidth : null;
    const height = hasWindow ? window.innerHeight : null;
    return {
      width,
      height,
    };
  }
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  useEffect(() => {
    if (hasWindow) {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasWindow]);
  return windowDimensions;
};

export const CalcAverageRating = (ratings = []) => {
  if (ratings.length === 0) return 0;
  return (
    Math.round((ratings.reduce((x, y) => x + y, 0) / ratings.length) * 100) /
    100
  );
};

export const ScrollToBottom = (ref) => {
  if (ref && ref.current) {
    const { scrollHeight, clientHeight } = ref.current;
    ref.current.scrollTo({
      left: 0,
      top: scrollHeight - clientHeight,
    });
  }
};

export const GetMonths = () => {
  const date = new Date();
  return [
    `01/${date.getFullYear()}`,
    `02/${date.getFullYear()}`,
    `03/${date.getFullYear()}`,
    `04/${date.getFullYear()}`,
    `05/${date.getFullYear()}`,
    `06/${date.getFullYear()}`,
    `07/${date.getFullYear()}`,
    `08/${date.getFullYear()}`,
    `09/${date.getFullYear()}`,
    `10/${date.getFullYear()}`,
    `11/${date.getFullYear()}`,
    `12/${date.getFullYear()}`,
  ];
};

export const IsEmptyObj = (obj) =>
  obj !== undefined && obj !== null && Object.keys(obj).length === 0
    ? true
    : false;

export const RmvEmptyProp = (obj) =>
  !IsEmptyObj(obj) &&
  Object.fromEntries(
    Object.keys(obj)
      .filter((k) => obj[k])
      .map((k) => [k, obj[k]])
  );

export const RmvArryEmptyProp = (val) =>
  Object.fromEntries(
    Object.keys(val)
      .filter((k) => val[k] !== "")
      .map((key) => [
        key,
        Array.isArray(val[key])
          ? val[key].map((j) => RmvEmptyProp(j))
          : val[key],
      ])
  );

export const BGNestedObjToFromData = (obj) => {
  const formData = new FormData();

  const traverse = (current, parentKey = "") => {
    for (const key in current) {
      if (current.hasOwnProperty(key)) {
        const value = current[key];

        // Skip if the property is empty or null
        if (value === null || value === undefined || value === "") {
          continue;
        }

        const newKey = parentKey ? `${parentKey}.${key}` : key;
        if (value instanceof File) {
          formData.append(newKey, value);
        } else if (Array.isArray(value)) {
          for (let i = 0; i < value.length; i++) {
            if (value[i] instanceof File) {
              formData.append(`${newKey}`, value[i]);
            } else if (value[i] instanceof Object) {
              traverse(value[i], `${newKey}[${i}]`);
            } else {
              formData.append(`${newKey}[${i}]`, value[i]);
            }
          }
        } else if (value instanceof Object) {
          traverse(value, newKey);
        } else {
          formData.append(newKey, value);
        }
      }
    }
  };

  traverse(obj);
  return formData;
};

export const ToFormData = (object) => {
  const formData = new FormData();
  Object.keys(object).forEach((key) =>
    !Array.isArray(object[key])
      ? formData.append(key, object[key])
      : object[key].forEach((val) => formData.append(key, val))
  );
  return formData;
};

export const GetDueDate = (date) => {
  return `${moment(date, "mm/DD/yyyy").format("DD")}/${moment().format(
    "MM/yyyy"
  )}`;
};

export const NestedFormData = (object, keyName = "imgsFile") => {
  const formData = new FormData();
  Object.keys(object).forEach((key) => {
    if (!Array.isArray(object[key])) formData.append(key, object[key]);
    else if (key === keyName)
      object[key].forEach((val) => formData.append(key, val));
    else
      object[key].forEach((val, i) =>
        Object.keys(val).forEach((key1) =>
          formData.append(`${key}[${i}][${key1}]`, val[key1])
        )
      );
  });
  return formData;
};

export const PrintDiv = (printDivId) => {
  var printContents = document.getElementById(printDivId).innerHTML;
  var frame1 = document.createElement("iframe");
  frame1.name = "frame1";
  frame1.style.position = "absolute";
  frame1.style.top = "-1000000px";
  document.body.appendChild(frame1);
  var frameDoc = frame1.contentWindow
    ? frame1.contentWindow
    : frame1.contentDocument.document
    ? frame1.contentDocument.document
    : frame1.contentDocument;

  frameDoc.document.open();
  frameDoc.document.write("<html><head><title></title>");
  frameDoc.document.write("</head><body>");
  frameDoc.document.write(printContents);
  frameDoc.document.write("</body></html>");
  frameDoc.document.close();

  setTimeout(function () {
    window.frames["frame1"].focus();
    window.frames["frame1"].print();
    document.body.removeChild(frame1);
  }, 100);

  return false;
};

export const RandomCode = (length = 12) => {
  var date = new Date();
  return (date.getDate() + date.getTime()).toString().slice(-length);
};

export const MaxLength = (val, length = 5) => {
  return val && val.replace(/[^0-9.]/g, "").slice(0, length);
};
